// One wording and one colour per status, used by every screen in the app.
// label  — the words shown to the user
// pill   — filled badge (Pill component)
// border — outlined badge
// tone   — plain coloured text
const S = (label, pill, border, tone) => ({ label, pill, border, tone });

export const STATUS = {
  draft: S("draft", "bg-secondary text-muted-foreground", "border-border text-muted-foreground",
    "text-muted-foreground"),
  open: S("open", "bg-secondary text-secondary-foreground", "border-border text-foreground",
    "text-foreground"),
  pending: S("pending", "bg-[#FFF3E6] text-[#B4530A]", "border-[#B4530A] text-[#B4530A]",
    "text-[#B4530A]"),
  scanning: S("scanning", "bg-[#FFF3E6] text-[#B4530A]", "border-[#B4530A] text-[#B4530A]",
    "text-[#B4530A]"),
  partial: S("partial", "bg-[#FFF3E6] text-[#B4530A]", "border-[#B4530A] text-[#B4530A]",
    "text-[#B4530A]"),
  received: S("received", "bg-[#E6F6EC] text-[#1F7A45]", "border-[#1F7A45] text-[#1F7A45]",
    "text-[#1F7A45]"),
  dispatched: S("dispatched", "bg-accent text-accent-foreground", "border-[#0055FF] text-[#0044CC]",
    "text-[#0044CC]"),
  delivered: S("delivered", "bg-[#E6F6EC] text-[#1F7A45]", "border-[#1F7A45] text-[#1F7A45]",
    "text-[#1F7A45]"),
  cancelled: S("cancelled", "bg-secondary text-muted-foreground line-through",
    "border-border text-muted-foreground line-through", "text-muted-foreground"),
  voided: S("voided", "bg-[#FDECEC] text-[#B31D1D]", "border-[#B31D1D] text-[#B31D1D]",
    "text-[#B31D1D]"),

  // billing states
  not_billed: S("not billed", "bg-[#FDECEC] text-[#B31D1D] border-[#F3B4B4]",
    "border-[#B31D1D] text-[#B31D1D]", "text-[#B31D1D]"),
  partly_billed: S("partly billed", "bg-[#E8F1FF] text-[#0044CC] border-[#B8D0F7]",
    "border-[#0055FF] text-[#0044CC]", "text-[#0044CC]"),
  fully_billed: S("fully billed", "bg-[#E6F6EC] text-[#1F7A45]", "border-[#1F7A45] text-[#1F7A45]",
    "text-[#1F7A45]"),
  awaiting_grn: S("awaiting GRN", "bg-[#FFF4E5] text-[#8A4B08] border-[#F3D3A8]",
    "border-[#8A4B08] text-[#8A4B08]", "text-[#8A4B08]"),

  // box / dispatch cycle states
  box_ready: S("box ready", "bg-[#E8F1FF] text-[#0044CC]", "border-[#0055FF] text-[#0044CC]",
    "text-[#0044CC]"),
  awaiting_box: S("awaiting box", "bg-[#FFF3E6] text-[#B4530A]", "border-[#B4530A] text-[#B4530A]",
    "text-[#B4530A]"),
};

const key = (k) => String(k || "").trim().toLowerCase().replace(/\s+/g, "_");

export const statusLabel = (k, fallback) => STATUS[key(k)]?.label ?? (fallback ?? k ?? "—");
export const statusPill = (k) => STATUS[key(k)]?.pill || "bg-secondary";
export const statusBorder = (k) => STATUS[key(k)]?.border || "border-border text-muted-foreground";
export const statusTone = (k) => STATUS[key(k)]?.tone || "";
